import { DashboardType } from "@doitintl/cmp-models";

export enum IntegrationName {
  OpenAI = "openai",
  Datadog = "datadog",
  Snowflake = "snowflake",
}

export const getFriendlyIntegrationName = (integrationName: string): string => {
  const friendlyNames: Record<string, string> = {
    openai: "OpenAI",
  };

  return (
    friendlyNames[integrationName.toLowerCase()] ||
    // Fallback: capitalize first letter if no mapping exists
    integrationName.charAt(0).toUpperCase() + integrationName.slice(1)
  );
};

export const getIntegrationLensUrl = (integrationName: string): string =>
  `https://help.doit.com/docs/${integrationName.toLowerCase()}/${integrationName.toLowerCase()}-lens`;

const integrationLensTextMap: Record<string, { TITLE?: string; LIST?: string[] }> = {
  snowflake: {
    TITLE: "Get real-time visibility into your Snowflake usage",
  },
};

export const getIntegrationLensText = (integrationName: string) => {
  const defaultText = {
    TITLE: `Identify & optimize ${getFriendlyIntegrationName(integrationName)} costs`,
    LIST: [
      `Analyze your ${getFriendlyIntegrationName(integrationName)} costs patterns`,
      "Monitor your historical data trends and cost implications",
      "Identify underutilized resources to optimize performance and cost",
      `Highlight the major cost drivers within your ${getFriendlyIntegrationName(integrationName)} environment`,
    ],
  };

  const integrationText = integrationLensTextMap[integrationName.toLowerCase()];

  return {
    TITLE: integrationText?.TITLE ?? defaultText.TITLE,
    LIST: integrationText?.LIST ?? defaultText.LIST,
  };
};

export const isCommonIntegrationLens = (dashboardType: DashboardType | null | undefined) =>
  dashboardType &&
  [DashboardType.OpenAILens, DashboardType.DatadogLens, DashboardType.SnowflakeLens].includes(dashboardType);

const dashboardTypeToIntegrationNameMap: Partial<Record<DashboardType, IntegrationName>> = {
  [DashboardType.OpenAILens]: IntegrationName.OpenAI,
  [DashboardType.DatadogLens]: IntegrationName.Datadog,
  [DashboardType.SnowflakeLens]: IntegrationName.Snowflake,
};

export const getIntegrationNameFromDashboardType = (dashboardType: DashboardType): IntegrationName | null =>
  dashboardTypeToIntegrationNameMap[dashboardType] ?? null;
